import {httpGet,httpPut,httpDelete,httpPost} from '../../../util/request.js';
import appConfig from '../../../config';

export default class ModuleFuncTypeApi{

	static QUERY_MODULE_FUNC_TYPE_API_URL = appConfig.gatewayUrl+appConfig.smpServicePath+"/sys/moduleFuncTypes";
	static QUERY_WEBPAY_TYPE_API_URL = appConfig.gatewayUrl + appConfig.smpServicePath + "/sys/webpageTypes";

	// static QUERY_MODULE_FUNC_TYPE_API_URL = "http://localhost:10064"+appConfig.smpServicePath+"/sys/moduleFuncTypes";
	// static QUERY_WEBPAY_TYPE_API_URL = "http://localhost:10064" + appConfig.smpServicePath + "/sys/webpageTypes";
	
	static queryModuleFuncType(){
		let params={};
		return httpGet(ModuleFuncTypeApi.QUERY_MODULE_FUNC_TYPE_API_URL,params);
	}

	static queryWebpageType(){
		let params={};
		return httpGet(ModuleFuncTypeApi.QUERY_WEBPAY_TYPE_API_URL,params);
	}
	
}